import AssemblyVsBonusly from "../../components/compare/AssemblyVsBonusly";

export { Page }

function Page() {
  return <AssemblyVsBonusly />;
}